import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiFragment, MediaType, MH2MediaType, RecordTypeStructure } from '@stylehaven/components';
import { SearchService } from '../../common/services/api/search.service';

@Injectable({ providedIn: 'root' })
export class HasKeyFramesGuard {
    private readonly keyFrameMediaTypes: MH2MediaType[] = [MediaType.document, MediaType.newspaper];
    constructor(private recordService: SearchService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.recordService
            .getRecord(route.parent?.params.recordId)
            .pipe(map(currentRecord => this.hasAccess(currentRecord)));
    }

    public hasAccess(record: ApiFragment): boolean {
        return (
            record.getRecordStructure() === RecordTypeStructure.DataFlat &&
            this.keyFrameMediaTypes.includes(record.getType())
        );
    }

    public isEnabled(record: ApiFragment): boolean {
        return !record.isProcessing();
    }
}
